import React from "react";
import type { PeriodStats, StatsDateRange, StatsGranularity } from "../../../api/stats/Stats.typed";
import { useStats } from "../../../contexts/api";
import { BREAKDOWN_GRANULARITY } from "../statsPeriodHelpers";

export function usePeriodStatsData(
  granularity: StatsGranularity,
  range: StatsDateRange,
  enabled: boolean,
) {
  const { getPeriodStats } = useStats();
  const [summary, setSummary] = React.useState<PeriodStats | null>(null);
  const [breakdown, setBreakdown] = React.useState<PeriodStats[]>([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!enabled) {
      setSummary(null);
      setBreakdown([]);
      return;
    }
    let stale = false;
    const breakdownGranularity = BREAKDOWN_GRANULARITY[granularity];
    setLoading(true);
    void Promise.all([
      getPeriodStats(granularity, range),
      breakdownGranularity ? getPeriodStats(breakdownGranularity, range) : Promise.resolve([]),
    ]).then(([summaryRows, breakdownRows]) => {
      if (stale) return;
      setSummary(summaryRows?.[0] ?? null);
      setBreakdown([...(breakdownRows ?? [])].reverse());
      setLoading(false);
    });
    return () => {
      stale = true;
    };
  }, [enabled, getPeriodStats, granularity, range]);

  return { summary, breakdown, loading };
}
